import React from 'react';
import logo from '../../images/simorq_logo_vector_final_main.svg';

const IconLogo = () => (
  <img src={logo} alt="Simorq Logo" style={{ width: '100%', height: '100%' }} />
);

export default IconLogo;
